<header-menu></header-menu>
<div class="center-content">
  <div id="establishment-create-special-disclosure" class="card">
    <div class="card-content">
      <h1 class="no-margin">Criar divulgação especial</h1>
      <p>
        Você já é visualizado por todas empresas e seus usuários através da plataforma.
      </p>
      <p>
        Estes formatos foram criados para proporcionar ao seu negócio um destaque especial GRATUITO através de notificação no celular (push) e computadores.
      </p>
      <p>
        <strong>Para participar basta criar uma ofertas a seguir:</strong>
      </p>

      <div class="fancy-buttons">
        <a href="https://app.pipefy.com/public/form/fDXEMnvm" target="_blank" class="btn-fancy">
          <span>
            <img src="../../../assets/shared/img/svg/sorteio.svg" alt="" />
            <div class="content-text">
              <strong>Sorteio</strong>
              Ofereça um ou mais prêmios para serem sorteados dentre os usuários que participarem.
            </div>
          </span>
        </a>
        <a href="https://app.pipefy.com/public/form/T99juWt2" target="_blank" class="btn-fancy">
          <span>
            <img src="../../../assets/shared/img/svg/bag.svg" alt="" />
            <div class="content-text">
              <strong>Promoção relâmpago</strong>
              Desconto maior ou condição diferenciada, adicional à proposta vigente, por um período pré-definido.
            </div>
          </span>
        </a>
      </div>

      <!-- FASE 2 -->
      <!-- ====== -->
      
      <!-- 
      <h1>Divulgações especiais criadas</h1>
      <h2>Sorteios</h2>
      <div class="responsive-table no-padding">
        <table class="table table-striped table-no-border table-ellipsis">
          <thead>
            <tr>
              <th>Prêmios</th>
              <th>Regiões</th>
              <th>Vigência</th>
              <th>Data do sorteio</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="data-ellipsis"><span>Voucher de 10 sessões de depilação</span></td>
              <td>Brasil</td>
              <td>10/10/2017 - 20/10/2017</td>
              <td>21/10/2017</td>
              <td>Em vigência</td>
              <td class="one-button">
                <button class="btn-green">Ver detalhes</button>
              </td>
            </tr>
            <tr>
              <td class="data-ellipsis"><span>Voucher de 10 sessões de depilação</span></td>
              <td>Brasil</td>
              <td>10/10/2017 - 20/10/2017</td>
              <td>21/10/2017</td>
              <td>Em vigência</td>
              <td class="one-button">
                <button class="btn-green">Ver detalhes</button>
              </td>
            </tr>
            <tr>
              <td class="data-ellipsis"><span>Voucher de 10 sessões de depilação</span></td>
              <td>Brasil</td>
              <td>10/10/2017 - 20/10/2017</td>
              <td>21/10/2017</td>
              <td>Em vigência</td>
              <td class="one-button">
                <button class="btn-green">Ver detalhes</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2>Promoções relâmpago</h2>
      <div class="responsive-table no-padding">
        <table class="table table-striped table-no-border">
          <thead>
            <tr>
              <td>Título</td>
              <td>Vigência</td>
              <td>Status</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="content-width">10% de desconto</td>
              <td class="content-width">10/10/2017 - 20/10/2017</td>
              <td class="content-width">Em vigência</td>
              <td class="one-button">
                <button class="btn-green">Ver detalhes</button>
              </td>
            </tr>
            <tr>
              <td class="content-width">10% de desconto</td>
              <td class="content-width">10/10/2017 - 20/10/2017</td>
              <td class="content-width">Em vigência</td>
              <td class="one-button">
                <button class="btn-green">Ver detalhes</button>
              </td>
            </tr>
            <tr>
              <td class="content-width">10% de desconto</td>
              <td class="content-width">10/10/2017 - 20/10/2017</td>
              <td class="content-width">Em vigência</td>
              <td class="one-button">
                <button class="btn-green">Ver detalhes</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      -->

      <!-- FASE 2 -->
      <!-- ====== -->

    </div>
  </div>
</div>
